import React from 'react';
import { Trans } from 'react-i18next';

export default {
  columns: [
    {
      id: 'dateFormatted',
      label: <Trans i18nKey='date'/>,
      index: true,
    },

    {
      id: 'description',
        label: <Trans i18nKey='Description'/>,
    },
    {
      id: 'bonusMonth',
      label: <Trans i18nKey='bonusmonth'/>,
    },
    {
      id: 'creditFormatted',
      label: <Trans i18nKey='credit'/>,
    },
    {
      id: 'debitFormatted',
      label: <Trans i18nKey='debit'/>,
    },
    {
      id: 'balanceFormatted',
      label: <Trans i18nKey='balance'/>,
    },
    {
      id: 'series',
      label: <Trans i18nKey='series'/>,
    },
  ],
};
